import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openAlignClipsSnackbarDL,
  closeAlignClipsSnackbarDL,
  clearAlignClipsResponseDL,
  openAlignClipsSnackbarWS,
  closeAlignClipsSnackbarWS,
  clearAlignClipsResponseWS,
  closeCombineClipsSnackbar,
  openCombineClipsSnackbar,
  clearCombineClipsResponse,
  closeUploadingSnackbar,
  openUploadingSnackbar,
  toggleUploadingSnackbar,
  openImportErrorSnackbar,
  closeImportErrorSnackbar,
  clearImportErrorMessage,
} from ".";

export const useSnackbars = () => {
  const dispatch = useDispatch();
  const snackbarState = useSelector((state) => state.snackbars);

  const handleAlignClipsOpen = useCallback(
    (message) => {
      return dispatch(openAlignClipsSnackbarDL(message));
    },
    [dispatch],
  );

  const handleAlignClipsClose = useCallback(() => {
    return dispatch(closeAlignClipsSnackbarDL());
  }, [dispatch]);

  const handleAlignClipsClear = useCallback(() => {
    return dispatch(clearAlignClipsResponseDL());
  }, [dispatch]);

  const handleAlignClipsOpenWS = useCallback(
    (message) => {
      return dispatch(openAlignClipsSnackbarWS(message));
    },
    [dispatch],
  );

  const handleAlignClipsCloseWS = useCallback(() => {
    return dispatch(closeAlignClipsSnackbarWS());
  }, [dispatch]);

  const handleAlignClipsClearWS = useCallback(() => {
    return dispatch(clearAlignClipsResponseWS());
  }, [dispatch]);

  const handleCombineClipsOpen = useCallback(
    (message) => {
      return dispatch(openCombineClipsSnackbar(message));
    },
    [dispatch],
  );

  const handleCombineClipsClose = useCallback(() => {
    return dispatch(closeCombineClipsSnackbar());
  }, [dispatch]);

  const handleCombineClipsClear = useCallback(() => {
    return dispatch(clearCombineClipsResponse());
  }, [dispatch]);

  const handleImportErrorOpen = useCallback(
    (message) => {
      return dispatch(openImportErrorSnackbar(message));
    },
    [dispatch],
  );

  const handleImportErrorClose = useCallback(() => {
    return dispatch(closeImportErrorSnackbar());
  }, [dispatch]);

  const handleImportErrorClear = useCallback(() => {
    return dispatch(clearImportErrorMessage());
  }, [dispatch]);

  const handleUploadingOpen = useCallback(() => {
    return dispatch(openUploadingSnackbar());
  }, [dispatch]);

  const handleUploadingClose = useCallback(() => {
    return dispatch(closeUploadingSnackbar());
  }, [dispatch]);

  const handleUploadingToggle = useCallback(() => {
    return dispatch(toggleUploadingSnackbar());
  }, [dispatch]);

  return {
    // State
    alignClipsResponseDL: snackbarState.alignClipsResponseDL,
    showAlignClipsSnackbarDL: snackbarState.showAlignClipsSnackbarDL,
    alignClipsResponseWS: snackbarState.alignClipsResponseWS,
    showAlignClipsSnackbarWS: snackbarState.showAlignClipsSnackbarWS,
    combineClipsResponse: snackbarState.combineClipsResponse,
    showCombineClipsSnackbar: snackbarState.showCombineClipsSnackbar,
    showImportErrorSnackbar: snackbarState.showImportErrorSnackbar,
    importErrorMessage: snackbarState.importErrorMessage,
    showUploadingSnackbar: snackbarState.showUploadingSnackbar,

    // Actions
    openAlignClipsSnackbarDL: handleAlignClipsOpen,
    closeAlignClipsSnackbarDL: handleAlignClipsClose,
    clearAlignClipsResponseDL: handleAlignClipsClear,
    openAlignClipsSnackbarWS: handleAlignClipsOpenWS,
    closeAlignClipsSnackbarWS: handleAlignClipsCloseWS,
    clearAlignClipsResponseWS: handleAlignClipsClearWS,
    openCombineClipsSnackbar: handleCombineClipsOpen,
    closeCombineClipsSnackbar: handleCombineClipsClose,
    clearCombineClipsResponse: handleCombineClipsClear,
    openImportErrorSnackbar: handleImportErrorOpen,
    closeImportErrorSnackbar: handleImportErrorClose,
    clearImportErrorMessage: handleImportErrorClear,
    openUploadingSnackbar: handleUploadingOpen,
    closeUploadingSnackbar: handleUploadingClose,
    toggleUploadingSnackbar: handleUploadingToggle,
  };
};
